export default "__VITE_ASSET__71453559__"